import { render, staticRenderFns } from "./MatchCalendarsPro.vue?vue&type=template&id=5a1da251&scoped=true"
import script from "./MatchCalendarsPro.vue?vue&type=script&lang=js"
export * from "./MatchCalendarsPro.vue?vue&type=script&lang=js"
import style0 from "./MatchCalendarsPro.vue?vue&type=style&index=0&id=5a1da251&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1da251",
  null
  
)

export default component.exports